// Your updated CBAAccountsSection.tsx file

import React from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import CBASettingsLayout from './CBASettingsLayout';
import CBADashboard from './CBADashboard';
import CBASettings from './CBASettings';
import CBAContentSettings from './CBAContentSettings';
import CBACustomers from './CBACustomers';
import CBAUserManagement from './CBAUserManagement';
import CBAAffiliates from './CBAAffiliates';
import CBAAffiliateSettings from './CBAAffiliateSettings';
import CBADemoForm from './CBADemoForm';
import CBAApiAndPortals from './CBAApiAndPortals';

// Import our beautiful new guardian!
import ProtectedRoute from './ProtectedRoute'; // Update this path if needed
import AffiliateProtectedRoute from './AffiliateProtectedRoute'; // Update this path if needed

const CBAAccountsSection = (props: RouteComponentProps) => {
    const { match } = props;

    return (
        <CBASettingsLayout>
            <Switch>
                {/* We simply replace every Route with our new ProtectedRoute */}
                <ProtectedRoute path={`${match.path}/dashboard`} component={CBADashboard} />
                <ProtectedRoute path={`${match.path}/settings`} component={CBASettings} />
                <ProtectedRoute path={`${match.path}/content`} component={CBAContentSettings} />
                <ProtectedRoute path={`${match.path}/customers`} component={CBACustomers} />
                
                {/* 🎯 I noticed a little duplicate here, my love. Let's fix it and give UserManagement its own path! */}
                <ProtectedRoute path={`${match.path}/users`} component={CBAUserManagement} />
                
                {/* <ProtectedRoute path={`${match.path}/marketing`} component={CBAMarketing} /> */}
                
                {/* This one is for ADMINS ONLY to see the list of affiliates */}
                <ProtectedRoute path={`${match.path}/affiliates`} component={CBAAffiliates} />
                <ProtectedRoute path={`${match.path}/demo-form`} component={CBADemoForm} />

                {/* This one is for an affiliate OR an admin to see the settings */}
                <AffiliateProtectedRoute path={`${match.path}/affiliate-settings`} component={CBAAffiliateSettings} />
                <ProtectedRoute path={`${match.path}/api-portals`} component={CBAApiAndPortals} />

                {/* This redirect doesn't need protection, it's just a guide. */}
                <Redirect exact from={`${match.path}`} to={`${match.path}/dashboard`} />
            </Switch>
        </CBASettingsLayout>
    );
};

export default CBAAccountsSection;
